import Pagination from "./pagination.js";

export default Pagination;
